import { TableDefine } from '@/libs/tableHelper/type'
import { GenealogyApplyBriefByEntry } from '@/api/genealogy/GenealogyApplyBriefByEntry'
import { User } from '@/api/user/User'

// 数据表格的列定义
export default function getTableDefine (view: any): TableDefine<GenealogyApplyBriefByEntry> {
  const tableCols = [
    {
      title: '申请人姓名',
      key: 'name'
    },
    {
      title: '申请人手机',
      key: 'phone'
    },
    {
      title: '申请族谱',
      key: 'genealogyName'
    },
    {
      title: '父亲姓名',
      key: 'fatherName'
    },
    {
      title: '母亲姓名',
      key: 'motherName'
    },
    {
      title: '状态',
      key: 'status',
      type: {
        module: 'enum',
        enum: 'genealogy/agree'
      }
    },
    {
      title: '申请时间',
      type: {
        module: 'time',
        format: 'yyyy-MM-DD HH:mm:ss'
      },
      key: 'createTime'
    }
  ]

  const actions: any = [
    {
      name: 'agree',
      title: '通过申请',
      show: (item: any) => {
        return item.status === 1
      },
      modal: {
        message: '确定要通过该申请吗？'
      },
      onClick: (dataItem: User) => {
        view.agreeHandle(dataItem)
      }
    },
    {
      name: 'back',
      title: '驳回申请',
      color: 'red',
      show: (item: any) => {
        return item.status === 1
      },
      modal: {
        message: '确定要驳回该申请吗？'
      },
      onClick: (dataItem: User) => {
        view.onRejectHandle(dataItem)
      }
    }
    // {
    //   name: 'view-back',
    //   title: '查看驳回理由',
    //   show: (item: any) => {
    //     return item.status === 2
    //   },
    //   onClick: (dataItem: User) => {
    //     view.onViewReject(dataItem)
    //   }
    // }
  ]

  return {
    tableCols,
    actions,
    actionWidth: 180
  }
}
